const affiliateDetailsResource = {
    success:'Affiliate details loaded successfully!',
    error:'Error loading affiliate details!'   
 }
 
 export default affiliateDetailsResource;